import { useCallback } from 'react'
import { useMutation } from '@apollo/client'

import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { useStores } from '~/hooks/useStores'

import { GET_UNREAD_MESSAGE_TOTAL_COUNT, READ_MESSAGE } from '~/graphqls/gqls'
import {
  BaseMsgType,
  readMessage,
  readMessageVariables,
  getUnreadTotalCount,
  getUnreadTotalCountVariables,
} from '~/graphqls/types'

export const useMsg = () => {
  const { store } = useStores()

  /** 未读消息总数 */
  const getUnreadTotalCount = useImperativeQuery<
    getUnreadTotalCount,
    getUnreadTotalCountVariables
  >(GET_UNREAD_MESSAGE_TOTAL_COUNT)

  /** 读信息 */
  const [readMsgAction] = useMutation<readMessage, readMessageVariables>(
    READ_MESSAGE
  )

  const handleReadMsg = useCallback(
    (type: BaseMsgType) => {
      return readMsgAction({
        variables: {
          type: type,
        },
      })
    },
    [readMsgAction]
  )

  /** 未读消息总数 */
  const handleUnreadCount = useCallback(async () => {
    try {
      const resp = await getUnreadTotalCount({
        // 剔除不需要统计的分类
        notNeed: [BaseMsgType.COMMENT],
        // 过滤屏蔽的分类
        skipShield: true,
      })
      if (resp?.data?.count >= 0) {
        store?.setMsgCount(resp?.data?.count)
      }
    } catch (error) {}
  }, [getUnreadTotalCount])

  return {
    readMsgAction,
    handleReadMsg,
    handleUnreadCount,
  }
}
